import _ from "lodash";
import React, { Component } from "react";
import { Div, Image } from "atomize";
import ImageLazyLoad from "../common/ImageLazyLoad";
import ImageLink from "./ImageLink";

class FullVideoCard extends Component {
  render() {
    const { card, ...rest } = this.props;

    return (
      <Div {...rest} cursor="pointer">
        <div>
          <Div pos="relative">
            <ImageLazyLoad
              className="video-card"
              bgImg={_.get(card, "image.file.url")}
              bgSize="cover"
              p={{ b: "120.3%" }}
              pos="relative"
            >
              <Div
                pos="absolute"
                top="0"
                left="0"
                w="100%"
                h="100%"
                bg="rgba(0, 0, 0, 0.5)"
              ></Div>
              <Div
                pos="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
              >
                <Image src="/images/play-btn.svg" h="6.25rem" w="6.25rem" />
              </Div>
            </ImageLazyLoad>
          </Div>
        </div>
      </Div>
    );
  }
}

export default FullVideoCard;
